import { Code, ConnectError } from '@connectrpc/connect'

const E = 'page:adminWorkflowTemplates.autoCreationRule.serverError'

/**
 * 自動起票ルールの保存・削除の失敗の出し先と文言 (AC-WFT-052 / 054 / 056)。
 * backend は ErrorInfo の reason を付けないので gRPC code で振り分ける。
 */
export type AutoCreationRuleErrorDisplay =
  | { kind: 'field'; field: 'templateId' | 'areaCodes'; messageKey: string }
  | { kind: 'banner'; messageKey: string; reloadable: boolean }
  /** 先に削除されていた。モーダルを閉じて一覧を読み直し、エラーの toast を出す。 */
  | { kind: 'deleted'; messageKey: string }

const conflict: AutoCreationRuleErrorDisplay = {
  kind: 'banner',
  messageKey: `${E}.aborted`,
  reloadable: true,
}

const deleted: AutoCreationRuleErrorDisplay = {
  kind: 'deleted',
  messageKey: `${E}.deleted`,
}

export function mapAutoCreationRuleSaveError(
  err: unknown,
  mode: 'create' | 'edit',
): AutoCreationRuleErrorDisplay {
  if (err instanceof ConnectError) {
    switch (err.code) {
      case Code.AlreadyExists:
        // 編集はキー (雛形・エリア・起票リード) を変えないので AlreadyExists は届かない
        if (mode === 'edit') break
        return {
          kind: 'field',
          field: 'areaCodes',
          messageKey: `${E}.allAreasAlreadyExist`,
        }
      case Code.FailedPrecondition:
        // 編集は雛形の欄を変えられないので、欄ではなくモーダル内のエラーに出す
        if (mode === 'edit') {
          return {
            kind: 'banner',
            messageKey: `${E}.editTemplateNotEligible`,
            reloadable: false,
          }
        }
        return {
          kind: 'field',
          field: 'templateId',
          messageKey: `${E}.templateNotEligible`,
        }
      case Code.Aborted:
        return conflict
      case Code.NotFound:
        return deleted
    }
  }
  return { kind: 'banner', messageKey: `${E}.saveFailed`, reloadable: false }
}

export function mapAutoCreationRuleDeleteError(
  err: unknown,
): AutoCreationRuleErrorDisplay {
  if (err instanceof ConnectError) {
    if (err.code === Code.Aborted) return conflict
    if (err.code === Code.NotFound) return deleted
  }
  return { kind: 'banner', messageKey: `${E}.deleteFailed`, reloadable: false }
}
